import React from "react";

const ADO_Connection = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Connection</h1>
      <p>This is the ADO Connection page content.</p>
    </div>
  );
};

export default ADO_Connection;
